import React from 'react'
import styledComponents from '../styles/MenuTab-style'
const { CustomMenuContainer, IconsContainer, IconsContainer02, MudIcon, SaltIcon, SeaweedIcon, BoardIcon, MenuBackground, BackIcon, BackIcon02, BackIcon03,BackIcon04 } = styledComponents;
// import { Link } from 'react-router-dom'

const MenuTab = (props) => {
    const { handleMenuId, MenuId } = props;
    return (
        <CustomMenuContainer>
            <MenuBackground
            />
            <IconsContainer>
                <MudIcon alt="갯벌" src="./images/a_icon.png" onClick={() => handleMenuId(0)} left={40} selected={MenuId === 0 ? true : false} />
                <SaltIcon alt="염습지" src="./images/b_icon.png" onClick={() => handleMenuId(2)} selected={MenuId === 2 ? true : false} />
                <SeaweedIcon alt="해초대" src="./images/c_icon.png" onClick={() => handleMenuId(1)} selected={MenuId === 1 ? true : false} />                
                <BoardIcon alt="게시판" src="./images/photo.jpg" onClick={() => handleMenuId(3)} selected={MenuId === 3 ? true : false} />
            </IconsContainer>
            <IconsContainer>
                {MenuId === 0 && <BackIcon top={33} left={32} />}
                {MenuId === 2 && <BackIcon03 top={43} left={132} />}
                {MenuId === 1 && <BackIcon02 right={32} />}
                {MenuId === 3 && <BackIcon04 top={84} right={32} />}
            </IconsContainer>
            <IconsContainer02>
                {MenuId === 0 && <div style={{ height: "41px", padding: "10px" }}></div>}
                {MenuId !== 0 && <div style={{ height: "41px", padding: "10px" }}>갯벌</div>}
                {MenuId === 2 && <div style={{ height: "41px", padding: "10px" }}></div>}
                {MenuId !== 2 && <div style={{ height: "41px", padding: "10px" }}>염습지</div>}
                {MenuId === 1 && <div style={{ height: "41px", padding: "10px" }}></div>}
                {MenuId !== 1 && <div style={{ height: "41px", padding: "10px" }}>해초대</div>}
                {MenuId === 3 && <div style={{ height: "41px", padding: "10px" }}></div>}
                {MenuId !== 3 && <div style={{ height: "41px", padding: "10px" }}>게시판</div>}
            </IconsContainer02>
        </CustomMenuContainer>
    )
}

export default MenuTab;